export default "__VITE_ASSET__BUyHjksW__"